import { LatestMatchesList } from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/H2H/LatestMatchesList";
import { Last5MeetingsList } from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/H2H/Last5MeetingsList";
import PreviouseMeetings from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/H2H/PreviouseMeetings";

interface H2HProps {
    h2hData: any;
}

const H2H = ({ h2hData }: H2HProps) => {
    return (
        <div data-testid="h2h-container" className='sm351:w-[319px] w-full'>
            <div data-testid="h2h-previous-meetings" className='mt-[8px]'>
                <PreviouseMeetings previousMeetings={h2hData?.score} />
            </div>
            {h2hData?.last_5_meetings?.length > 0 && (
                <div data-testid="h2h-last-5-meetings-list" className='mt-[16px] mb-[16px]'>
                    <Last5MeetingsList last5Meetings={h2hData?.last_5_meetings} />
                </div>
            )}
            {h2hData?.latest_matches_home?.length > 0 && <div data-testid="h2h-latest-matches-home" className='mb-[16px] mt-[16px]'>
                <LatestMatchesList homeTeam={h2hData?.score?.homeTeam} awayTeam={null} data={h2hData?.latest_matches_home} />
            </div>}
            {h2hData?.latest_matches_away?.length > 0 && <div data-testid="h2h-latest-matches-away" className='mb-[5px]'>
                <LatestMatchesList homeTeam={null} awayTeam={h2hData?.score?.awayTeam} data={h2hData?.latest_matches_away} />
            </div>}
        </div>
    )
}

export default H2H;  